<template>
  <div class="mySwitch">
    <!-- 显示所有图片 -->
    <div
      class="image-row"
      ref="imageRow"
      :style="{
        transform: `translateX(${-imageOffset + transformX}px)`,
        transition: 'transform 1.2s ease',
      }"
    >
      <img
        v-for="item in navItems"
        :key="item.id"
        :class="{ highlighted: currentItem && item.id === currentItem.id }"
        style="width: 931px; height: 568px"
        :src="item.url"
        alt=""
      />
    </div>
    <!-- 显示当前选中项的文字信息 -->
    <div class="slider-container">
      <!-- 左箭头 -->
      <div class="menu_direction">
        <div
          class="arrow left"
          @click="moveLeft"
          :style="{
            opacity: currentIndex === 0 ? 0.3 : 1,
            display: currentIndex === 0 ? 'none' : 'block',
          }"
        >
          <i class="el-icon-arrow-left"></i>
        </div>
      </div>

      <!-- 外部容器，固定宽度并溢出隐藏 -->
      <div class="outer-box" ref="outerBox">
        <!-- 内部容器，根据数据渲染 -->
        <div
          class="inner-box"
          ref="innerBox"
          :style="{
            transform: `translateX(-${titleOffset}px)`,
            transition: 'transform 0.3s ease',
          }"
        >
          <div
            v-for="item in navItems"
            :key="item.id"
            class="item"
            :class="{ active: currentItem && item.id === currentItem.id }"
            @click="selectItem(item)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <!-- 右箭头 -->
      <div class="menu_direction">
        <div
          class="arrow right"
          @click="moveRight"
          :style="{
            opacity: canScrollRightForTitle() ? 1 : 0.3,
            display: canScrollRightForTitle() ? 'block' : 'none',
          }"
        >
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
    <div class="SwitchText" v-if="currentItem">{{ currentItem.msg }}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navItems: [
        {
          id: "001",
          title: "Lens Measurement and Positioning Process",

          msg: "Automatically calculate and complete the measurement data file within 5 minutes.Precisely align the virtual camera in the 3D world with the real camera coordinates on-site, ensuring no distortion.",
          url: "https://download.hecoos.com/enlightv/2025-17/37f549101ac217def309cf249ff30e36.png",
        },
        {
          id: "002",
          title: "Latency Calibration",

          msg: "Measure camera delay, media delay, and manually adjust tracking delay to ensure perfect synchronization between the screen and extended visuals, eliminating issues such as stuttering and tearing.",
          url: "https://download.hecoos.com/enlightv/2025-17/bfadae3a04c9937fddfdbedf990bc4c8.png",
        },
        {
          id: "003",
          title: "Color Calibration",

          msg: "Automatically calculate calibration files by comparing the colors captured by the camera on the LED screen and the original input, ensuring accurate color matching between the screen and extended visuals.",
          url: "https://download.hecoos.com/enlightv/2025-17/7e6c8a04ff7f81a12ff5bca98b38bbb2.png",
        },
        {
          id: "004",
          title: "Multi-camera switching",

          msg: "When the number of tracking systems is perfectly matched to the cameras, the director can seamlessly switch between tracking positions in real time, capturing a dynamic range of visuals to convey a rich and varied visual language.",
          url: "https://download.hecoos.com/enlightv/2025-17/ccac8c851186e55acae1dc6ac1d105f7.png",
        },
        {
          id: "005",
          title: "Engine Level/Sequence Management",

          msg: "Link multiple virtual scene programs added to the Server-C server timeline with their corresponding scene levels in Unreal Engine, enabling instant control and triggering of sequence animations within the virtual scenes.",
          url: "https://download.hecoos.com/enlightv/2025-17/23207610ab5776b51566e965a4053b44.png",
        },
        {
          id: "006",
          title: "Virtual and Real Lighting Synchronization Control",

          msg: "Construct the lighting layout of the real studio based on the virtual scene's lighting configuration. hecoos uses the ART-NET protocol to directly control real lights, achieving synchronized interaction between virtual and real lighting",
          url: "https://download.hecoos.com/enlightv/2025-17/be90db821f444481cb55fef8a09dbce3.png",
        },
        {
          id: "007",
          title: "Rivermax Cluster Rendering",

          msg: "Share the rendered view of the inner frustum across cluster nodes to optimize resource usage and avoid rendering inefficiencies. By distributing tasks across multiple nodes, the visual quality is enhanced, and the performance remains smoother.The SMPTE 2110 synchronization strategy is applied to frame-lock each rendering node, ensuring seamless synchronization between the Unreal Engine output and the camera feed.",
          url: "https://download.hecoos.com/enlightv/2025-37/d92591f17ac050bb0e27402e12edd0cf.png",
        },
      ],
      currentIndex: 0,
      offset: 0,
      visibleItems: 0,
      currentItem: null,
      totalWidth: 0,
      imageOffset: 0,
      titleOffset: 0,
      titleWidths: [],
      transformX: 0,
      marginWidth: 40,
      safetyMargin: 10, // 修改：新增安全边距，防止边缘文字被切
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.innerBox && this.$refs.outerBox) {
        this.currentItem = this.navItems[0];
        this.calculateTitleWidths();
        this.calculateVisibleItemsForTitle();
        this.calculateTotalWidthForTitle();
        this.centerSelectedImage();
        this.centerSelectedTitle();
        let number = Math.floor(this.navItems.length / 2);
        let transformX = 1111 * number - 931 / 3;
        this.transformX = transformX;
      }
    });
  },
  methods: {
    moveLeft() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        const step = this.titleWidths[this.currentIndex] + this.marginWidth;
        this.titleOffset -= step;
        // 确保偏移量不小于0
        this.titleOffset = Math.max(0, this.titleOffset);
        // 重新计算可见项
        this.calculateVisibleItemsForTitle();
      }
    },
    moveRight() {
      if (this.currentIndex < this.navItems.length - 1) {
        this.currentIndex++;
        const step = this.titleWidths[this.currentIndex] + this.marginWidth;
        const visibleWidth = this.getVisibleWidth();
        this.titleOffset += step;
        // 确保偏移量不超过总宽度减去可见宽度
        // 修改：优化右移边界判断，增加安全边距
        this.titleOffset = Math.min(
          this.titleOffset,
          this.totalWidth - visibleWidth + this.safetyMargin
        );
        // 重新计算可见项
        this.calculateVisibleItemsForTitle();
      }
    },
    selectItem(item) {
      const prevIndex = this.currentIndex;
      this.currentItem = item;
      this.currentIndex = this.navItems.findIndex((i) => i.id === item.id);

      // 使用 setTimeout 延迟执行图片切换逻辑
      setTimeout(() => {
        // 计算图片偏移量
        const itemWidth = 931 + 80;
        const targetImageIndex = this.currentIndex;
        const visibleWidth = this.getVisibleWidth();
        const totalItems = this.navItems.length;
        let targetOffset = 0;

        if (totalItems <= this.visibleItems) {
          // 所有图片都可见，将选中图片居中
          targetOffset = (visibleWidth - itemWidth) / 2;
        } else {
          // 计算选中图片在容器中的位置
          targetOffset =
            targetImageIndex * itemWidth - (visibleWidth - itemWidth) / 2 - 62;
          // 边界处理
          targetOffset = Math.max(
            0,
            Math.min(
              targetOffset,
              (totalItems - 1) * itemWidth - visibleWidth + itemWidth
            )
          );
        }
        this.imageOffset = targetOffset;
        // 计算标题偏移量
        const itemWidthTitle = this.titleWidths[this.currentIndex];
        let targetOffsetTitle = 0;
        for (let i = 0; i < this.currentIndex; i++) {
          targetOffsetTitle += this.titleWidths[i] + this.marginWidth;
        }

        targetOffsetTitle = Math.max(
          0,
          Math.min(
            targetOffsetTitle,
            this.totalWidth - visibleWidth + itemWidthTitle
          )
        );
        const centerOffset =
          targetOffsetTitle - (visibleWidth - itemWidthTitle) / 2;
        this.titleOffset = centerOffset;

        this.centerSelectedTitle();
        // 重新计算可见项，确保布局正确
        this.calculateVisibleItemsForTitle();
      }, 500); // 延迟 500 毫秒，可根据需要调整
    },
    calculateTitleWidths() {
      const titles = this.$refs.innerBox.querySelectorAll(".item");
      this.titleWidths = Array.from(titles).map((title) => title.offsetWidth);
    },
    calculateVisibleItemsForTitle() {
      if (this.$refs.innerBox && this.$refs.outerBox) {
        const outerBoxWidth = this.$refs.outerBox.offsetWidth;
        let totalWidth = 0;
        let visibleCount = 0;
        const items = this.$refs.innerBox.children;
        for (let i = 0; i < items.length; i++) {
          totalWidth += this.titleWidths[i];
          if (i > 0) {
            totalWidth += this.marginWidth;
          }
          // 修改：增加安全边距判断，避免计算时超出容器
          if (totalWidth <= outerBoxWidth + this.safetyMargin) {
            visibleCount++;
          } else {
            break;
          }
        }
        this.visibleItems = visibleCount;
      }
    },
    calculateTotalWidthForTitle() {
      let total = 0;
      for (let i = 0; i < this.titleWidths.length; i++) {
        total += this.titleWidths[i];
        if (i > 0) {
          total += this.marginWidth;
        }
      }
      this.totalWidth = total;
    },
    getVisibleWidth() {
      return this.$refs.outerBox ? this.$refs.outerBox.offsetWidth : 0;
    },
    canScrollRightForTitle() {
      return this.currentIndex < this.navItems.length - 1;
    },
    centerSelectedImage() {
      const visibleWidth = this.getVisibleWidth();
      const itemWidth = 931 - 80; // 图片宽度加上右边距
      const itemIndex = this.currentIndex;
      const totalItems = this.navItems.length;
      let targetOffset = 0;

      if (totalItems <= this.visibleItems) {
        // 所有图片都可见，将选中图片居中
        targetOffset = (visibleWidth - itemWidth) / 2;
      } else {
        // 计算选中图片在容器中的位置
        targetOffset = itemIndex * itemWidth - (visibleWidth - itemWidth) / 2;
        // 边界处理
        targetOffset = Math.max(
          0,
          Math.min(
            targetOffset,
            (totalItems - 1) * itemWidth - visibleWidth + itemWidth
          )
        );
      }

      this.offset = targetOffset;
      this.imageOffset = targetOffset;
    },
    centerSelectedTitle() {
      const visibleWidth = this.getVisibleWidth();
      const itemIndex = this.currentIndex;
      const itemWidth = this.titleWidths[itemIndex];
      let targetOffset = 0;
      for (let i = 0; i < itemIndex; i++) {
        targetOffset += this.titleWidths[i] + this.marginWidth;
      }

      // 确保偏移量在合理范围内，防止越界
      // targetOffset = Math.max(0, Math.min(targetOffset, this.totalWidth - visibleWidth + itemWidth));

      // 计算让选中项居中的偏移量
      let centerOffset = targetOffset - (visibleWidth - itemWidth) / 2;

      // 处理边界情况，避免偏移量计算异常
      centerOffset = Math.max(
        0,
        Math.min(centerOffset, this.totalWidth - visibleWidth)
      );
      this.titleOffset = centerOffset;
    },
  },
  watch: {
    "$el.clientWidth": {
      handler() {
        this.calculateTitleWidths();
        this.calculateVisibleItemsForTitle();
        this.calculateTotalWidthForTitle();
        this.centerSelectedImage();
        this.centerSelectedTitle();
      },
      immediate: false,
    },
  },
};
</script>

<style scoped>
.mySwitch {
  /* padding: 0 120px 80px; */
  background-color: #000;
  display: flex;
  /* 垂直方向为y轴 */
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #818186;
}

.slider-container {
  display: flex;
  align-items: center;
  position: relative;
  width: 970px;
  margin-top: 50px;
}
.menu_direction {
  width: 40px;
  height: 46px;
}
.arrow {
  color: #fff;
  cursor: pointer;
  padding: 10px;
  font-size: 20px;
  user-select: none;
}

.outer-box {
  width: 1000px;
  overflow: hidden;
  border-bottom: 0.1px #383838 solid;
}

.inner-box {
  display: flex;
  transition: transform 0.3s ease;
}

.item {
  padding: 10px 0;
  margin: 0 15px;
  box-sizing: border-box;
  cursor: pointer;
  font-size: 20px;
  white-space: nowrap;
  /* 为文字的颜色和下划线添加过渡效果 */
  transition: color 0.3s ease, border-bottom 0.3s ease;
}

.item.active {
  color: #fff;
  border-bottom: 2px solid #cccccc;
}

.SwitchText {
  width: 850px;
  height: 150px;
  text-align: center;
  margin-top: 50px;
  font-size: 20px;
  transition: opacity 1s ease, visibility 0.3s ease; /* 添加过渡属性 */
  color: #ffffff;
}

.image-row {
  display: flex;
  flex-direction: row;
  transition: transform 0.5s ease;
  gap: 80px;
  padding-top: 50px;
}

.highlighted {
  filter: brightness(1); /* 高亮状态，亮度为1 */
  transition: filter 1.5s ease; /* 添加过渡效果，1秒的延迟 */
}

img:not(.highlighted) {
  filter: brightness(0.5); /* 未选中状态，亮度为0.5，可以根据需要调整 */
}
</style>
